<template lang="pug">
header.EventHeaderNav
  .EventHeaderNav-content
    .header-side
      router-link.svgBox(:to="{ name: 'EventIndex' }")
        img.svglogo(src="../assets/img/index/weijianliku.png")
      .tabs
        router-link.tab(
          v-for="(item, i) in pages",
          :key="i",
          :to="item.path",
          :class="{ checked: currentPath === item.path }"
        ) {{ item.name }}
    .details
      EventHeaderSearch
      //- .search
      //-   input(
      //-     type="search",
      //-     v-model="keyword",
      //-     @keydown.enter="search",
      //-     placeholder="请输入关键词检索案例"
      //-   )
      //-   button.fa.fa-search(@click.prevent="search")
      //- .vip(:class="{ isVip: isVip }") {{ levelName }}
      header-user
</template>

<script>
import HeaderUser from './HeaderUser'
// import store from '../store'
import EventHeaderSearch from './EventHeaderSearch'
export default {
  name: 'EventHeaderNav',
  components: {
    HeaderUser, EventHeaderSearch
  },
  // beforeRouteEnter (to, from, next) {
  //   // 已经登陆时请求用户信息
  //   if (store.getters.logged) {
  //     store.dispatch('GetUserinfo')
  //       .then(res => {
  //         next()
  //       })
  //   } else {
  //     next()
  //   }
  // },
  data () {
    return {
      keyword: '',
      pages: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '事件库',
          path: '/collect'
        },
        {
          name: '危机图谱',
          path: '/CrisisChart'
        },
        {
          name: '危机专题',
          path: '/crisisTopic'
        },
        {
          name: '危机研究',
          path: '/report'
        },
        {
          name: '口径库',
          path: '/caliberLibrary'
        }
      ]
    }
  },
  computed: {
    showSearchInput () {
      return this.roleId === 2 || this.roleId === 3
    },
    roleId () {
      return this.$store.getters.roleId
    },
    levelName () {
      return this.$store.getters.levelName
    },
    isVip () {
      return this.$store.getters.isVip
    },
    params () {
      return this.$store.state.search.params
    },
    currentPath () {
      return this.$route.path
    }
  },
  watch: {
    '$route.params' () {
      this.keyword = this.$route.params.keyword
    }
  },
  methods: {
    search () {
      // let params = this.params
      // let keyword = this.keyword
      if (!this.keyword) {
        return false
      }
      // params = Object.assign({}, params, {
      //   keyword: keyword,
      //   page: 1
      // })
      // this.$store.dispatch('GlobalSearch', params)
      this.$router.push({
        name: 'EventSearch',
        params: {
          keyword: this.keyword
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.EventHeaderNav {
  width: 100%;
  .EventHeaderNav-content {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
}
header {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 60px;
  // background: url("../assets/loginbg.png");
  background-color: #1f72f2;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.details {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.header-navs {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.header-side {
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
}

.svgBox {
  height: 40px;
  padding-left: 31px;
  display: flex;
  align-items: center;
}

.svglogo {
  width: 230px;
}
.tabs {
  margin-left: 60px;
  display: flex;
  .tab {
    margin: 0 20px;
    font-size: 16px;
    color: #fff;
    position: relative;
    &.checked {
      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 25px;
        height: 4px;
        background: #fff;
        bottom: -10px;
        border-radius: 5px;
      }
    }
  }
}

.search {
  margin-right: 30px;
  border-bottom: 1px solid #ddd;
  width: 200px;
  display: flex;
  flex-flow: row nowrap;
  height: 22px;
  line-height: 22px;
  color: #fff;

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    text-indent: 4px;

    &::placeholder {
      color: #bbb;
      font-size: 14px;
    }
  }

  button {
    width: 35px;
    background: transparent;
    border: none;
    color: #cccccc;
    font-size: 1.2em;
  }
}

.vip {
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background-color: #f3f3f3;
  border-radius: 13px;
  color: #666666;
  margin-right: 20px;

  &.isVip {
    background-color: #ffc884;
    color: #7c561e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/EventHeaderNav.vue